import React from 'react';
import AuthPageReader from '../AuthPageReader.jsx';

const EducationSignInReader = (props) => <AuthPageReader {...props} domainType="EDUCATION" pageKey="signIn" />;

export default EducationSignInReader;
